// extracted by mini-css-extract-plugin
module.exports = {"content4":"styles_content4__1GrFK","container":"styles_container__rca64","box2":"styles_box2__1Qfof","box":"styles_box__2imIl","article":"styles_article__3Ohlz"};